import { useAnalytics } from 'src/lib/contexts/AnalyticsContext'
import { WidgetId, WidgetSections } from 'src/lib/contexts/AnalyticsContext/types'

export const CheckSection = ({
  widgetSection,
  children
}: {
  widgetSection: WidgetSections
  children: React.ReactNode
}) => {
  const {
    getters: { widgetConfig }
  } = useAnalytics()

  return widgetConfig[widgetSection] ? children : null
}

export const CheckWidget = ({ widgetId, children }: { widgetId: WidgetId; children: React.ReactNode }) => {
  const {
    getters: { widgetConfig }
  } = useAnalytics()

  const mergedWidgetConfig = {
    ...widgetConfig?.conversion,
    ...widgetConfig?.payments,
    ...widgetConfig?.discounts,
    ...widgetConfig?.orders
  }

  return mergedWidgetConfig[widgetId] ? children : null
}
